import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _reverseInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reverse";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { isString, isArray, isFunction } from 'lodash';
export function resolveTargets(_ref) {
  var _context, _context2, _context3, _context4;

  var token = _ref.token,
      _ref$base = _ref.base,
      base = _ref$base === void 0 ? null : _ref$base,
      target = _ref.target,
      type = _ref.type;

  // Filter out undefined or null and reverse
  // order beacuse we're working inside out
  var targets = _reverseInstanceProperty(_context = _filterInstanceProperty(_context2 = isArray(target) ? _toConsumableArray(target) : [target]).call(_context2, function (t) {
    return t !== null && t !== void 0 ? t : false;
  })).call(_context);

  var types = _reverseInstanceProperty(_context3 = _filterInstanceProperty(_context4 = isArray(type) ? _toConsumableArray(type) : [type]).call(_context4, function (t) {
    return t !== null && t !== void 0 ? t : false;
  })).call(_context3);

  return _reduceInstanceProperty(targets).call(targets, function (acc, target) {
    return _reduceInstanceProperty(types).call(types, function (acc, type) {
      var _context5;

      return token(_concatInstanceProperty(_context5 = "".concat(target, ".")).call(_context5, type), acc);
    }, acc);
  }, base);
}
export function resolveTokenStyleValue(_ref2) {
  var token = _ref2.token,
      tokenKey = _ref2.tokenKey,
      value = _ref2.value;

  if (isString(value)) {
    var _context6;

    // Assume if the user passes a string to
    // these fallbacks they want a value
    // from the base tokens
    return token(_concatInstanceProperty(_context6 = "".concat(tokenKey, ".")).call(_context6, value));
  } else if (isFunction(value)) {
    // Otherwise return whatever value they decide
    return value({
      token: token
    });
  }
}
export function resolveTextStyleValue(_ref3) {
  var token = _ref3.token,
      type = _ref3.type,
      tokenKey = _ref3.tokenKey,
      value = _ref3.value;

  if (isString(value)) {
    var _context7, _context8;

    // Assume if the user passes a string to
    // these fallbacks they want a value
    // from the base tokens
    return token(_concatInstanceProperty(_context7 = _concatInstanceProperty(_context8 = "".concat(tokenKey, ".")).call(_context8, value, ".")).call(_context7, type));
  } else if (isFunction(value)) {
    // Otherwise return whatever value they decide
    return value({
      token: token
    });
  }
}
export function resolveFallbacks(_ref4) {
  var _context9, _context10;

  var token = _ref4.token,
      type = _ref4.type,
      _ref4$base = _ref4.base,
      base = _ref4$base === void 0 ? null : _ref4$base,
      fallback = _ref4.fallback,
      tokenKey = _ref4.tokenKey,
      resolver = _ref4.resolver;

  // Filter out undefined or null and reverse
  // order beacuse we're working inside out
  var fallbacks = _reverseInstanceProperty(_context9 = _filterInstanceProperty(_context10 = isArray(fallback) ? _toConsumableArray(fallback) : [fallback]).call(_context10, function (f) {
    return f !== null && f !== void 0 ? f : false;
  })).call(_context9);

  return _reduceInstanceProperty(fallbacks).call(fallbacks, function (acc, fallback) {
    var _resolver;

    return (_resolver = resolver({
      token: token,
      type: type,
      tokenKey: tokenKey,
      value: fallback
    })) !== null && _resolver !== void 0 ? _resolver : acc;
  }, resolver({
    token: token,
    type: type,
    tokenKey: tokenKey,
    value: base
  }));
}
export function generateTokenFn(_ref5) {
  var target = _ref5.target,
      base = _ref5.base,
      type = _ref5.type,
      fallback = _ref5.fallback,
      tokenKey = _ref5.tokenKey,
      _ref5$resolver = _ref5.resolver,
      resolver = _ref5$resolver === void 0 ? resolveTokenStyleValue : _ref5$resolver;
  return function (_ref6) {
    var token = _ref6.token;
    return resolveTargets({
      token: token,
      target: target,
      type: type,
      base: resolveFallbacks({
        token: token,
        type: type,
        base: base,
        fallback: fallback,
        tokenKey: tokenKey,
        resolver: resolver
      })
    });
  };
}